/*
 * @Author: RogersHuang
 * @Date: 2022-01-08 16:10:22
 * @LastEditors: RogersHuang
 * @LastEditTime: 2022-04-02 20:30:46
 * @FilePath: /camel-oms-web/src/tools/storage.ts
 */
// local
export function saveToLocal (name, value) {
  window.localStorage.setItem(name, JSON.stringify(value))
}

export function loadFromLocal (name) {
  const localStorageName = window.localStorage.getItem(name)
  try {
    if (localStorageName) {
      return JSON.parse(localStorageName)
    } else {
      return ''
    }
  } catch (e) {
    return ''
  }
}

export function removeFromLocal (name) {
  window.localStorage.removeItem(name)
}
